import { Box, Card, CardContent, Grid, makeStyles, Theme, Typography } from "@material-ui/core";
import { CheckSharp } from "@material-ui/icons";
import { Backdrop } from "@mui/material";
import { useFormik } from "formik";
import moment from "moment";
import "moment-timezone";
import React, { useEffect, useRef, useState } from "react";
import { useAppSelector } from "src/app-redux/hooks";
import { loader } from "src/app-redux/insights/insightsSlice";
import CommonAutoCompleteField from "src/components/CommonAutoCompleteField/CommonAutoCompleteField";
import CommonButton from "src/components/CommonButton/CommonButton";
import CommonTextFieldDate from "src/components/CommonTextFieldForDate/CommonTextFieldDate";
import TabHeader from "src/components/TabHeader/TabHeader";
import { InsightsRoute } from "../../insight.routes";
import { Revenue } from "./components/revenue'/Revenue";
import { Vehicles } from "./components/Vehicle/Vehicles";
import { Yard } from "./components/yard/Yard";
import { filteryByArr } from "src/common/utils/app.dropdowns";
import { Cargo } from "./components/cargo/Cargo";
import { fetchWrapper } from "src/api-client/fetchWrapper";
import CommonLoader from "src/components/Loader/CommonLoader";

const useStyles = makeStyles((theme: Theme) => ({
  cardMain: {
    marginBottom: "0px",
    paddingTop: "2px",
    width: "calc(100%)",
    overflow: "scroll",
  },
  pageHeading: {
    fontSize: theme.typography.pxToRem(24),
    fontWeight: theme.typography.fontWeightRegular,
    color: "#000",
  },
  backdrop: {
    zIndex: theme.zIndex.modal + 1,
    color: "#fff",
  },
  hideDatesGrid: {
    display: "none",
  },
  checkButton: {
    color: "#ffffff",
    backgroundColor: "#72CA00",
    padding: "8px",
  },
  vehiclesItem: {
    border: "0.5px solid #E6E6E6",
    borderRadius: "8px",
    boxShadow: "0px 0px 2px #00000029",
    padding: "15px 15px 0 15px",
    // marginBottom: "15px",
  },
}));

interface Props {}

export function Listing({}: Props): React.ReactElement {
  const classes = useStyles();
  const moduleName = InsightsRoute.title;
  const pageHeading = "Insights";
  const loading = useAppSelector(loader);
  const [isRevenueCustomDate, setIsRevenueCustomDate] = useState<boolean>(false);
  const [isVehicleCustomDate, setIsVehicleCustomDate] = useState<boolean>(false);
  const [isCargoCustomDate, setIsCargoCustomDate] = useState<boolean>(false);
  const scrollContainerRef: any = useRef(null);
  const revenuestartDatePickerRef: any = useRef(null);
  const revenueendDatePickerRef: any = useRef(null);
  const vehiclestartDatePickerRef: any = useRef(null);
  const vehicleendDatePickerRef: any = useRef(null);
  const cargostartDatePickerRef: any = useRef(null);
  const cargoendDatePickerRef: any = useRef(null);
  const [consignmentTypeList, setconsignmentTypeList] = React.useState<any>([]);
  const [consignmentTypeName, setConsignmentTypeName] = React.useState<any>("Import");
  const td = new Date();

  const formik = useFormik({
    initialValues: {
      revenueFilterBy: "today",
      revenueStartDate: moment(new Date(new Date().setDate(td.getDate())).setHours(0, 0)).format(
        "YYYY-MM-DDTHH:mm"
      ),
      revenueEndDate: moment(new Date(new Date().setDate(new Date().getDate()))).format(
        "YYYY-MM-DDTHH:mm"
      ),
      revenueStartDateCustom: moment(
        new Date(new Date().setDate(td.getDate() - 29)).setHours(0, 0)
      ).format("YYYY-MM-DDTHH:mm"),
      revenueEndDateCustom: moment(new Date(new Date().setDate(new Date().getDate()))).format(
        "YYYY-MM-DDTHH:mm"
      ),
      vehicleFilterBy: "today",
      vehicleStartDate: moment(new Date(new Date().setDate(td.getDate())).setHours(0, 0)).format(
        "YYYY-MM-DDTHH:mm"
      ),
      vehicleEndDate: moment(new Date(new Date().setDate(new Date().getDate()))).format(
        "YYYY-MM-DDTHH:mm"
      ),
      vehicleStartDateCustom: moment(
        new Date(new Date().setDate(td.getDate() - 29)).setHours(0, 0)
      ).format("YYYY-MM-DDTHH:mm"),
      vehicleEndDateCustom: moment(new Date(new Date().setDate(new Date().getDate()))).format(
        "YYYY-MM-DDTHH:mm"
      ),
      cargoFilterBy: "today",
      cargoStartDate: moment(new Date(new Date().setDate(td.getDate())).setHours(0, 0)).format(
        "YYYY-MM-DDTHH:mm"
      ),
      cargoEndDate: moment(new Date(new Date().setDate(new Date().getDate()))).format(
        "YYYY-MM-DDTHH:mm"
      ),
      cargoStartDateCustom: moment(
        new Date(new Date().setDate(td.getDate() - 29)).setHours(0, 0)
      ).format("YYYY-MM-DDTHH:mm"),
      cargoEndDateCustom: moment(new Date(new Date().setDate(new Date().getDate()))).format(
        "YYYY-MM-DDTHH:mm"
      ),
      yardFilterBy: "today",
      yardStartDate: moment(new Date(new Date().setDate(td.getDate())).setHours(0, 0)).format(
        "YYYY-MM-DDTHH:mm"
      ),
      yardEndDate: moment(new Date(new Date().setDate(new Date().getDate()))).format(
        "YYYY-MM-DDTHH:mm"
      ),
      yardStartDateCustom: moment(
        new Date(new Date().setDate(td.getDate() - 29)).setHours(0, 0)
      ).format("YYYY-MM-DDTHH:mm"),
      yardEndDateCustom: moment(new Date(new Date().setDate(new Date().getDate()))).format(
        "YYYY-MM-DDTHH:mm"
      ),

      showRevenue: true,
      showVehicles: true,
      showCargo: true,
      showYard: true,
    },
    onSubmit: () => {
      // handleSearch();
    },
  });
  const { values, setValues } = formik;

  const filterByAction = (data: any, module: string) => {
    const filter =
      module === "revenue"
        ? "revenueFilterBy"
        : module === "vehicle"
        ? "vehicleFilterBy"
        : module === "cargo"
        ? "cargoFilterBy"
        : module === "yard"
        ? "yardFilterBy"
        : "";
    const dateStart =
      module === "revenue"
        ? "revenueStartDate"
        : module === "vehicle"
        ? "vehicleStartDate"
        : module === "cargo"
        ? "cargoStartDate"
        : module === "yard"
        ? "yardStartDate"
        : "";
    const dateEnd =
      module === "revenue"
        ? "revenueEndDate"
        : module === "vehicle"
        ? "vehicleEndDate"
        : module === "cargo"
        ? "cargoEndDate"
        : module === "yard"
        ? "yardEndDate"
        : "";
    const dateStartCustom =
      module === "revenue"
        ? "revenueStartDateCustom"
        : module === "vehicle"
        ? "vehicleStartDateCustom"
        : module === "cargo"
        ? "cargoStartDateCustom"
        : module === "yard"
        ? "yardStartDateCustom"
        : "";
    const dateEndCustom =
      module === "revenue"
        ? "revenueEndDateCustom"
        : module === "vehicle"
        ? "vehicleEndDateCustom"
        : module === "cargo"
        ? "cargoEndDateCustom"
        : module === "yard"
        ? "yardEndDateCustom"
        : "";
    if (data && data.value) {
      const td = new Date();
      const todayStart = moment(new Date(new Date().setDate(td.getDate())).setHours(0, 0)).format(
        "YYYY-MM-DDTHH:mm"
      );
      const todayEnd = moment(new Date(new Date().setDate(td.getDate()))).format(
        "YYYY-MM-DDTHH:mm"
      );
      const yesterdayStart = moment(
        new Date(new Date().setDate(td.getDate() - 1)).setHours(0, 0)
      ).format("YYYY-MM-DDTHH:mm");
      const yesterdayEnd = moment(
        new Date(new Date().setDate(td.getDate() - 1)).setHours(23, 59)
      ).format("YYYY-MM-DDTHH:mm");
      const lastWeek = moment(new Date(new Date().setDate(td.getDate() - 6)).setHours(0, 0)).format(
        "YYYY-MM-DDTHH:mm"
      );
      const lastMonth = moment(
        new Date(new Date().setDate(td.getDate() - 29)).setHours(0, 0)
      ).format("YYYY-MM-DDTHH:mm");

      if (data.value === "today") {
        formik.setFieldValue(filter, "today");
        formik.setFieldValue(dateStart, todayStart);
        formik.setFieldValue(dateEnd, todayEnd);
      }
      if (data.value === "yesterday") {
        formik.setFieldValue(filter, "yesterday");
        formik.setFieldValue(dateStart, yesterdayStart);
        formik.setFieldValue(dateEnd, yesterdayEnd);
      }

      if (data.value === "lastWeek") {
        formik.setFieldValue(dateStart, lastWeek);
        formik.setFieldValue(dateEnd, todayEnd);
      }
      if (data.value === "lastMonth") {
        formik.setFieldValue(dateStart, lastMonth);
        formik.setFieldValue(dateEnd, todayEnd);
      }
      if (
        data.value === "today" ||
        data.value === "yesterday" ||
        data.value === "lastWeek" ||
        data.value === "lastMonth"
      ) {
        module === "revenue"
          ? setIsRevenueCustomDate(false)
          : module === "vehicle"
          ? setIsVehicleCustomDate(false)
          : module === "cargo"
          ? setIsCargoCustomDate(false)
          : "";
      }
      if (data.value === "custom") {
        module === "revenue"
          ? setIsRevenueCustomDate(true)
          : module === "vehicle"
          ? setIsVehicleCustomDate(true)
          : module === "cargo"
          ? setIsCargoCustomDate(true)
          : "";
        formik.setFieldValue(dateStartCustom, todayStart);
        formik.setFieldValue(dateEndCustom, todayEnd);
      }
    }
  };

  const submitCustomDateValues = (module: string) => {
    const dateStart =
      module === "revenue"
        ? "revenueStartDate"
        : module === "vehicle"
        ? "vehicleStartDate"
        : module === "cargo"
        ? "cargoStartDate"
        : module === "yard"
        ? "yardStartDate"
        : "";
    const dateEnd =
      module === "revenue"
        ? "revenueEndDate"
        : module === "vehicle"
        ? "vehicleEndDate"
        : module === "cargo"
        ? "cargoEndDate"
        : module === "yard"
        ? "yardEndDate"
        : "";
    const dateStartCustom =
      module === "revenue"
        ? formik.values.revenueStartDateCustom
        : module === "vehicle"
        ? formik.values.vehicleStartDateCustom
        : module === "cargo"
        ? formik.values.cargoStartDateCustom
        : module === "yard"
        ? formik.values.yardStartDateCustom
        : "";
    const dateEndCustom =
      module === "revenue"
        ? formik.values.revenueEndDateCustom
        : module === "vehicle"
        ? formik.values.vehicleEndDateCustom
        : module === "cargo"
        ? formik.values.cargoEndDateCustom
        : module === "yard"
        ? formik.values.yardEndDateCustom
        : "";
    formik.setFieldValue(dateStart, dateStartCustom);
    formik.setFieldValue(dateEnd, dateEndCustom);
  };

  useEffect(() => {
    const handleScroll = () => {
      // Hide the calendar when the container is scrolled
      revenuestartDatePickerRef?.current?.flatpickr?.close();
      revenueendDatePickerRef?.current?.flatpickr?.close();
      vehiclestartDatePickerRef?.current?.flatpickr?.close();
      vehicleendDatePickerRef?.current?.flatpickr?.close();
      cargostartDatePickerRef?.current?.flatpickr?.close();
      cargoendDatePickerRef?.current?.flatpickr?.close();
    };
    scrollContainerRef?.current?.addEventListener("scroll", handleScroll);
    return () => {
      scrollContainerRef?.current?.removeEventListener("scroll", handleScroll);
    };
  }, []);
  useEffect(() => {
    getConsignments();
  }, []);
  const getConsignments = async () => {
    const results = await fetchWrapper.get("get-all-vehicle-configuration");
    if (results.isSuccess === true) {
      setconsignmentTypeList(results.value.consignmentTypeData);
    }
  };
  return (
    <>
      <Backdrop className={classes.backdrop} open={loading}>
        <CommonLoader />
      </Backdrop>
      <TabHeader module={moduleName} heading={pageHeading} />
      <Box m={2} />
      <Card>
        <CardContent
        // className={classes.cardMain}
        // // ref={scrollContainerRef}
        // style={{ height: wHeight }}
        >
          {/* Vehicle and Yard Management */}

          <Grid container direction="row" spacing={2}>
            <Grid item xs={12} md={7} lg={7}>
              <Box className={classes.vehiclesItem}>
                <Grid container direction="row">
                  <Grid item>
                    <Typography variant="h5" component="div">
                      Vehicle Management
                    </Typography>
                  </Grid>
                  <Grid
                    container
                    item
                    spacing={2}
                    direction="row"
                    style={{ marginBottom: "8px", marginTop: "8px" }}
                  >
                    <Grid item xs={12} md={3} lg={3}>
                      <CommonAutoCompleteField
                        error={
                          formik.touched.vehicleFilterBy && Boolean(formik.errors.vehicleFilterBy)
                        }
                        helperText={formik.touched.vehicleFilterBy && formik.errors.vehicleFilterBy}
                        label="Filter by"
                        placeholder="Filter by"
                        cssClassName="customTextField"
                        disableClearable={true}
                        name="vehicleFilterBy"
                        optionsType={filteryByArr}
                        getOptionLabel={(option: any) => option.label || null}
                        onChange={(row: any) => {
                          row ? setValues({ ...values, vehicleFilterBy: row.value || "" }) : "";
                          if (row === null) {
                            formik.setFieldValue("filterBy", null);
                          }
                          filterByAction(row, "vehicle");
                        }}
                        value={
                          filteryByArr.find(
                            ({ value }: any) => value === formik.values.vehicleFilterBy
                          ) || ""
                        }
                      />
                    </Grid>

                    <Grid item xs={12} md={3} lg={3}>
                      <Box className={!isVehicleCustomDate ? classes.hideDatesGrid : ""}>
                        <CommonTextFieldDate
                          cssClassName="customTextField"
                          label={"Start Date"}
                          name={"vehicleStartDateCustom"}
                          datePickerRef={vehiclestartDatePickerRef}
                          value={formik.values.vehicleStartDateCustom}
                          onChange={(e: any) => {
                            formik.setFieldValue(
                              "vehicleStartDateCustom",
                              moment(e).format("YYYY-MM-DDTHH:mm")
                            );
                            formik.setFieldValue("vehicleEndDateCustom", "");
                          }}
                          maxDate={moment().format("YYYY-MM-DDTHH:mm")}
                        />
                      </Box>
                    </Grid>

                    <Grid item xs={12} md={3} lg={3}>
                      <Box className={!isVehicleCustomDate ? classes.hideDatesGrid : ""}>
                        <CommonTextFieldDate
                          cssClassName="customTextField"
                          label={"End Date"}
                          name={"vehicleEndDateCustom"}
                          datePickerRef={vehicleendDatePickerRef}
                          value={formik.values.vehicleEndDateCustom}
                          onChange={(e: any) => {
                            formik.setFieldValue(
                              "vehicleEndDateCustom",
                              moment(e).format("YYYY-MM-DDTHH:mm")
                            );
                          }}
                          minDate={formik.values.vehicleStartDateCustom}
                          maxDate={moment().format("YYYY-MM-DDTHH:mm")}
                        />
                      </Box>
                    </Grid>

                    <Grid item xs={12} md={3} lg={3}>
                      <Box className={!isVehicleCustomDate ? classes.hideDatesGrid : ""}>
                        <CommonButton
                          isGreen
                          cssClass={classes.checkButton}
                          onClick={() => {
                            submitCustomDateValues("vehicle");
                          }}
                        >
                          <CheckSharp />
                        </CommonButton>
                      </Box>
                    </Grid>
                  </Grid>
                </Grid>
                <Vehicles
                  startDate={formik.values.vehicleStartDate}
                  endDate={formik.values.vehicleEndDate}
                />
              </Box>
            </Grid>
            {/* Yard Management */}
            <Grid item xs={12} md={5} lg={5}>
              <Box className={classes.vehiclesItem}>
                <Typography variant="h5" component="div">
                  Yard Management
                </Typography>
                <Yard startDate={formik.values.yardStartDate} endDate={formik.values.yardEndDate} />{" "}
              </Box>
            </Grid>
          </Grid>

          {/* revenue */}

          <Box
            className={classes.vehiclesItem}
            style={{ marginTop: "20px", paddingBottom: "20px" }}
          >
            <Box style={{ width: "100%" }}>
              <Box style={{ float: "left" }}>
                <Typography variant="h5" component="div">
                  Revenue
                </Typography>
              </Box>

              <Box style={{ float: "right", margin: "auto" }}>
                <Box style={{ display: "flex" }}>
                  <Box style={{ width: "200px", marginLeft: "10px", marginBottom: "10px" }}>
                    <CommonAutoCompleteField
                      error={
                        formik.touched.revenueFilterBy && Boolean(formik.errors.revenueFilterBy)
                      }
                      helperText={formik.touched.revenueFilterBy && formik.errors.revenueFilterBy}
                      label="Filter by"
                      placeholder="Filter by"
                      name="revenueFilterBy"
                      cssClassName="customTextField"
                      disableClearable={true}
                      optionsType={filteryByArr}
                      getOptionLabel={(option: any) => option.label || null}
                      onChange={(row: any) => {
                        row ? setValues({ ...values, revenueFilterBy: row.value || "" }) : "";
                        if (row === null) {
                          formik.setFieldValue("revenueFilterBy", null);
                        }
                        filterByAction(row, "revenue");
                      }}
                      value={
                        filteryByArr.find(
                          ({ value }: any) => value === formik.values.revenueFilterBy
                        ) || ""
                      }
                    />
                  </Box>

                  <Box
                    style={{ width: "200px", marginLeft: "10px" }}
                    className={!isRevenueCustomDate ? classes.hideDatesGrid : ""}
                  >
                    <CommonTextFieldDate
                      cssClassName="customTextField"
                      label={"Start Date"}
                      name={"revenueStartDateCustom"}
                      datePickerRef={revenuestartDatePickerRef}
                      value={formik.values.revenueStartDateCustom}
                      onChange={(e: any) => {
                        formik.setFieldValue(
                          "revenueStartDateCustom",
                          moment(e).format("YYYY-MM-DDTHH:mm")
                        );
                        formik.setFieldValue("revenueEndDateCustom", "");
                      }}
                      maxDate={moment().format("YYYY-MM-DDTHH:mm")}
                    />
                  </Box>

                  <Box
                    style={{ width: "200px", marginLeft: "10px" }}
                    className={!isRevenueCustomDate ? classes.hideDatesGrid : ""}
                  >
                    <CommonTextFieldDate
                      cssClassName="customTextField"
                      label={"End Date"}
                      name={"revenueEndDateCustom"}
                      value={formik.values.revenueEndDateCustom}
                      datePickerRef={revenueendDatePickerRef}
                      onChange={(e: any) => {
                        formik.setFieldValue(
                          "revenueEndDateCustom",
                          moment(e).format("YYYY-MM-DDTHH:mm")
                        );
                      }}
                      minDate={formik.values.revenueStartDateCustom}
                      maxDate={moment().format("YYYY-MM-DDTHH:mm")}
                    />
                  </Box>

                  <Box
                    style={{ marginLeft: "10px" }}
                    className={!isRevenueCustomDate ? classes.hideDatesGrid : ""}
                  >
                    <CommonButton
                      isGreen
                      cssClass={classes.checkButton}
                      onClick={() => {
                        submitCustomDateValues("revenue");
                      }}
                    >
                      <CheckSharp />
                    </CommonButton>
                  </Box>
                </Box>
              </Box>
            </Box>
            <Box style={{ margin: "10px" }}>
              <Revenue
                startDate={formik.values.revenueStartDate}
                endDate={formik.values.revenueEndDate}
              />
            </Box>
          </Box>

          {/* cargo */}
          <Box
            className={classes.vehiclesItem}
            style={{ marginTop: "20px", paddingBottom: "20px" }}
          >
            <Box style={{ width: "100%" }}>
              <Box style={{ float: "left" }}>
                <Typography variant="h5" component="div">
                  Cargo
                </Typography>
              </Box>

              <Box style={{ float: "right", margin: "auto" }}>
                <Box style={{ display: "flex" }}>
                  <Box style={{ width: "200px", marginLeft: "10px", marginBottom: "10px" }}>
                    <CommonAutoCompleteField
                      cssClassName="customTextField"
                      // error={
                      //   formik.touched.consignmentTypeId &&
                      //   Boolean(formik.errors.consignmentTypeId)
                      // }
                      // helperText={
                      //   formik.touched.consignmentTypeId && formik.errors.consignmentTypeId
                      // }
                      label="Type of Consignment"
                      placeholder="Select Type Of Consignment"
                      name="consignmentTypeName"
                      optionsType={consignmentTypeList}
                      required
                      getOptionLabel={(option: any) => option.name || ""}
                      value={
                        consignmentTypeList.find((st: any) => st.name == consignmentTypeName) ||
                        null
                      }
                      onChange={(option: any) => {
                        if (option && option.id !== 0) {
                          setConsignmentTypeName(option.name);
                        }
                      }}
                    />
                  </Box>
                  <Box style={{ width: "200px", marginLeft: "10px", marginBottom: "10px" }}>
                    <CommonAutoCompleteField
                      error={formik.touched.cargoFilterBy && Boolean(formik.errors.cargoFilterBy)}
                      helperText={formik.touched.cargoFilterBy && formik.errors.cargoFilterBy}
                      label="Filter by"
                      placeholder="Filter by"
                      name="cargoFilterBy"
                      cssClassName="customTextField"
                      disableClearable={true}
                      optionsType={filteryByArr}
                      getOptionLabel={(option: any) => option.label || null}
                      onChange={(row: any) => {
                        row ? setValues({ ...values, cargoFilterBy: row.value || "" }) : "";
                        if (row === null) {
                          formik.setFieldValue("cargoFilterBy", null);
                        }
                        filterByAction(row, "cargo");
                      }}
                      value={
                        filteryByArr.find(
                          ({ value }: any) => value === formik.values.cargoFilterBy
                        ) || ""
                      }
                    />
                  </Box>
                  <Box
                    style={{ width: "200px", marginLeft: "10px" }}
                    className={!isCargoCustomDate ? classes.hideDatesGrid : ""}
                  >
                    <CommonTextFieldDate
                      cssClassName="customTextField"
                      label={"Start Date"}
                      name={"cargoStartDateCustom"}
                      datePickerRef={cargostartDatePickerRef}
                      value={formik.values.cargoStartDateCustom}
                      onChange={(e: any) => {
                        formik.setFieldValue(
                          "cargoStartDateCustom",
                          moment(e).format("YYYY-MM-DDTHH:mm")
                        );
                        formik.setFieldValue("cargoEndDateCustom", "");
                      }}
                      maxDate={moment().format("YYYY-MM-DDTHH:mm")}
                    />
                  </Box>
                  <Box
                    style={{ width: "200px", marginLeft: "10px" }}
                    className={!isCargoCustomDate ? classes.hideDatesGrid : ""}
                  >
                    <CommonTextFieldDate
                      cssClassName="customTextField"
                      label={"End Date"}
                      name={"cargoEndDateCustom"}
                      value={formik.values.cargoEndDateCustom}
                      datePickerRef={cargoendDatePickerRef}
                      onChange={(e: any) => {
                        formik.setFieldValue(
                          "cargoEndDateCustom",
                          moment(e).format("YYYY-MM-DDTHH:mm")
                        );
                      }}
                      minDate={formik.values.cargoStartDateCustom}
                      maxDate={moment().format("YYYY-MM-DDTHH:mm")}
                    />
                  </Box>
                  <Box
                    style={{ marginLeft: "10px" }}
                    className={!isCargoCustomDate ? classes.hideDatesGrid : ""}
                  >
                    <CommonButton
                      isGreen
                      cssClass={classes.checkButton}
                      onClick={() => {
                        submitCustomDateValues("cargo");
                      }}
                    >
                      <CheckSharp />
                    </CommonButton>
                  </Box>
                </Box>
              </Box>
            </Box>
            <Cargo
              startDate={formik.values.cargoStartDate}
              endDate={formik.values.cargoEndDate}
              consignmentTypeName={consignmentTypeName}
            />
          </Box>
        </CardContent>
      </Card>
    </>
  );
}
